import React from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components";

import Header from "./Components/Header";
import Footer from "./Components/Footer";

export default function AppLayout({
  user,
  setUser,
  state,
  setStateName,
  setSearchKey,
  setLandingKeyReset,
  landingKeyReset,
  numberOfNotes,
}) {
  return (
    <Container>
      <Header
        userInfo={user}
        passUser={setUser}
        state={state}
        passState={setStateName}
        changeSearchKey={setSearchKey}
        resetCourseKey={setLandingKeyReset}
        keyReset={landingKeyReset}
        numberOfNotifications={numberOfNotes}
      />
      <Main>
        <Outlet />
      </Main>
      <Footer />
    </Container>
  );
}

const Container = styled.div`
  position: relative;
  display: grid;
  grid-template-rows: auto 300px;
  width: 100%;
  height: 100vh;
  background-color: #f2f2f2;
`;

const Main = styled.div`
  background-color: #f2f2f2;
`;
